const fileDownloadButtonCompCalendar = {
  title: 'Generate report'
};

export default fileDownloadButtonCompCalendar;
